import MatomoTracker from './MatomoTracker';
import * as types from './types';
export default MatomoTracker;
export { types };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@datapunt/matomo-tracker-js/es/index.js
// module id = 768
// module chunks = 0